module.exports = __webpack_public_path__ + "img/banner1.94a97807.png";